import { SharePointIntegration } from '@/app/components/features/sharepoint/SharePointIntegration';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authed/(organization)/_layout/settings/_layout/integrations',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <SharePointIntegration />;
}
